import { Rate } from 'shared-types/Common';

export type EntityListItem = Rate & { id?: string };

export const findSelectedEntity = (
  metaEntity: { rates?: EntityListItem[]; rooms?: EntityListItem[] },
  entityId: string
) => {
  const entities = metaEntity.rates || metaEntity.rooms;
  return (
    entities?.find(({ rateId }) => String(entityId) === String(rateId)) ||
    entities?.find(({ id }) => String(entityId) === String(id))
  );
};
